import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const archivedIssuesEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-archived-issues-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
